// src/components/Header.jsx
import React from "react";
import { useNavigate, useLocation } from "react-router-dom";

export default function Header({
  title = "",
  showSubtitle = false,
  showBackButton = false,
  query = "",
  setQuery = () => {},
  hideSearchBar = false,
}) {
  const navigate = useNavigate();
  const location = useLocation();

  const handleBack = () => {
    try {
      setQuery("");
    } catch {}
    navigate("/");
    try {
      window.scrollTo({ top: 0, behavior: "instant" });
    } catch {}
  };

  const isHome = location.pathname === "/";
  const isAbout = location.pathname.toLowerCase().includes("about"); // ⬅ hide search here

  const titleStyle = {
    margin: 0,
    marginLeft: isHome ? "185px" : "0px",
  };

  return (
    <header
      style={{
        position: "sticky",
        top: 0,
        zIndex: 100,
        backgroundColor: "#252525",
        minHeight: "90px",
        display: "flex",
        alignItems: "center",
        borderBottom: "1px solid #1a1a1a",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          width: "100%",
          padding: "0 1rem",
          justifyContent: "space-between",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "0.75rem" }}>
          {showBackButton && !isHome && (
            <button
              onClick={handleBack}
              aria-label="Back to Homepage"
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "0.5rem",
                padding: "0.5rem 1.125rem", // 1/8 wider than before
                borderRadius: "9999px",
                border: "1px solid #444",
                background: "#f0f0f0",
                cursor: "pointer",
                userSelect: "none",
                whiteSpace: "nowrap",
              }}
              onMouseEnter={(e) =>
                (e.currentTarget.style.background = "#e5e5e5")
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.background = "#f0f0f0")
              }
            >
              <svg
                width="14"
                height="14"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
                style={{ display: "block" }}
              >
                <path
                  d="M9.75 3.25L5 8l4.75 4.75"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <span>Back to Homepage</span>
            </button>
          )}

          <h1 style={titleStyle}>{title}</h1>

          {showSubtitle && isHome ? (
            <div style={{ marginTop: "0.15rem" }}>Explore my Collection</div>
          ) : null}
        </div>

        {/* Hide search if explicitly hidden OR on About page */}
        {!(hideSearchBar || isAbout) ? (
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <div style={{ position: "relative", width: "min(340px, 38vw)" }}>
              <span
                style={{
                  position: "absolute",
                  left: "0.6rem",
                  top: "50%",
                  transform: "translateY(-50%)",
                  fontSize: "1rem",
                  color: "#888",
                  pointerEvents: "none",
                }}
              >
                🔍
              </span>

              <input
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                placeholder="Search filenames…"
                onKeyDown={(e) => {
                  if (e.key === "Escape") setQuery("");
                }}
                style={{
                  width: "100%",
                  padding: "0.55rem 2.5rem 0.55rem 2rem",
                  borderRadius: "9999px",
                  border: "1px solid #444",
                  outline: "none",
                }}
              />

              <button
                type="button"
                aria-label="Clear search"
                onClick={() => setQuery("")}
                style={{
                  position: "absolute",
                  right: "0.4rem",
                  top: "50%",
                  transform: "translateY(-50%)",
                  border: "none",
                  background: "transparent",
                  cursor: "pointer",
                  fontSize: "1.8rem",
                  lineHeight: 1,
                  color: "#ccc",
                }}
              >
                ×
              </button>
            </div>
          </div>
        ) : (
          <div />
        )}
      </div>
    </header>
  );
}
